// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
var setJSONItem = function (dictEncode) {
    return function (v) {
        return function (value) {
            return $foreign.setItem(v)(Foreign_Generic.encodeJSON(dictEncode)(value));
        };
    };
};
var readForeignMay = function (dictDecode) {
    var $11 = Data_Either.either(function (v) {
        return Data_Maybe.Nothing.value;
    })(Data_Maybe.Just.create);
    var $12 = Foreign_Generic.decodeJSON(dictDecode);
    return function ($13) {
        return $11(Control_Monad_Except.runExcept($12($13)));
    };
};
var getJSONItem = function (dictDecode) {
    return function (v) {
        return Data_Functor.map(Effect.functorEffect)(function (x) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Nullable.toMaybe(x))(readForeignMay(dictDecode));
        })($foreign.getItem(v));
    };
};
var sessionStorageWithFallback = /* #__PURE__ */ (function () {
    return new Restaumatic_Services_Storage.Storage(function (dictDecode) {
        return getJSONItem(dictDecode);
    }, function (dictEncode) {
        return setJSONItem(dictEncode);
    });
})();
export {
    sessionStorageWithFallback
};
//# sourceMappingURL=index.js.map
